import React from "react";
import { ChevronRightIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { images, technicianAssets, workflow } from "../../data/landing";
export function ProblemSection() {
  return <section className="bg-brand-800 px-4 py-16 text-white sm:py-20" data-id="element-233" data-mp="8iz8wcrfifoh">
      <div className="mx-auto max-w-4xl" data-id="element-234" data-mp="dibwx0u1dssn">
        <SectionHeading invert title={<>
              Stop guessing what to do with an ECU.{" "}
              <em className="italic text-brand-200" data-id="element-236" data-mp="3mrzg9ztqm1s">Start following a system.</em>
            </>} lead="This isn't another 50-hour course filled with information you'll eventually forget. I've seen the same problem again and again. A technician can have:" data-id="element-235" data-mp="3vprkcztoah6n" />

        <ul className="mx-auto mt-8 grid max-w-xl gap-2.5" data-id="element-237" data-mp="1jzp8ve59eb9n">
          {technicianAssets.map(a => <li key={a} className="flex items-center gap-3 rounded-xl bg-white/10 px-4 py-3 text-base font-medium" data-id="element-238" data-mp="1ozbo1t4ne1l3">
              <span className="h-2 w-2 shrink-0 rounded-full bg-brand-300" aria-hidden="true" data-id="element-239" data-mp="1nmjlfzg7dipt" />
              {a}…
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-lg leading-relaxed text-brand-100" data-id="element-240" data-mp="1wfwohu7ze0pm">
          …and still feel stuck when an unfamiliar ECU arrives. The problem isn't always a lack of knowledge.{" "}
          <strong className="text-white" data-id="element-241" data-mp="14ogrr7cpmxlo">The problem is not having a structured decision process.</strong>
        </p>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-white p-5 text-ink sm:p-8" data-id="element-242" data-mp="zqxdi7g0iktq">
          <p className="text-center text-sm font-semibold text-muted sm:text-base" data-id="element-243" data-mp="1dpx079jyspn9">
            Instead of jumping between videos, forums, manuals and notes, you follow one simple workflow:
          </p>
          <ol className="mt-5 grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-6" data-id="element-244" data-mp="2p3sj8tdzpijr">
            {workflow.map((step, i) => <li key={step} className="relative flex items-center gap-2 rounded-xl bg-brand-50 px-3 py-3" data-id="element-245" data-mp="2k5ha6kvirc2l" data-mpi={i}>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-700 text-xs font-bold text-white" data-id="element-246" data-mp="1huf9nu6nalva">
                  {i + 1}
                </span>
                <span className="text-sm font-extrabold uppercase text-brand-800" data-id="element-247" data-mp="1qtsjinyolcgj">{step}</span>
                {i < workflow.length - 1 && <ChevronRightIcon className="ml-auto hidden h-4 w-4 text-brand-300 lg:block" aria-hidden="true" data-id="element-248" data-mp="z2d1z8bzefx6" />}
              </li>)}
          </ol>
          <p className="mt-5 text-center text-base text-muted" data-id="element-249" data-mp="182hxol7tbpvi">
            So you spend less time wondering what to do next and more time working through the actual problem.
          </p>
        </div>

        <div className="mt-14 text-center" data-id="element-250" data-mp="fdu5e5onc08g">
          <h3 className="font-serif text-2xl font-extrabold leading-tight sm:text-3xl" data-id="element-251" data-mp="fd2mnvg5dwzl">
            The 6 volumes + 5 bonuses inside ECU Decision System™
          </h3>
          <img src={images.mockup} alt="All volumes and bonuses of ECU Decision System" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-252" data-mp="ctxvbwo7712v" />
        </div>

        <CTAButton className="mt-8 [&_p]:text-brand-100" label="Get the complete ECU Decision System™" subtext="Instant download · Lifetime access · One-time payment of $27 · 7-day guarantee" data-id="element-253" data-mp="7uuoc6onqks9" />
      </div>
    </section>;
}